'use client';

import { useMemo, useState } from 'react';
import CalculatorInputs from './CalculatorInputs';
import ResultsDisplay from './ResultsDisplay';
import { RoicValues } from './types';
import { calculateRoic } from './calculations';
import { ToolsTranslations } from '@/lib/translations/types';

interface Props {
  translations: ToolsTranslations['roic'];
}

export default function RoicCalculator({ translations }: Props) {
  const [values, setValues] = useState<RoicValues>({
    netIncomeAfterTax: 1000000,
    dividends: 0,
    longTermDebt: 100000,
    equity: 600000,
  });

  const handleValuesChange = (field: keyof RoicValues, value: number) => {
    setValues(prev => ({ ...prev, [field]: value }));
  };

  const result = useMemo(() => calculateRoic(values, translations), [values, translations]);

  return (
    <section id="roic-calculator" className="w-full my-12 tools">
      <div className="rounded-xl border border-gray-200 shadow-sm bg-white">
        <div className="p-6 border-b border-gray-100">
          <div>
            <h2 className="text-xl font-semibold text-blue-900">{translations.title}</h2>
            <p className="text-sm text-gray-600 mt-1">{translations.subtitle}</p>
          </div>
        </div>
        <div className="p-6 grid grid-cols-1 lg:grid-cols-2 gap-8">
          <CalculatorInputs values={values} onValuesChange={handleValuesChange} translations={translations} />
          <ResultsDisplay result={result} translations={translations} />
        </div>
      </div>
    </section>
  );
}


